import {RootState} from '../../../store/store';
import {useSelector} from 'react-redux';

function selector(state: RootState) {
    return state.themeColor.themecolor;
}

export function useTheme() {
  return useSelector<RootState, ReturnType<typeof selector>>(selector);
}
